import { render, staticRenderFns } from "./behavior.vue?vue&type=template&id=04310fb2&scoped=true"
import script from "./behavior.vue?vue&type=script&lang=js"
export * from "./behavior.vue?vue&type=script&lang=js"
import style0 from "./behavior.vue?vue&type=style&index=0&id=04310fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04310fb2",
  null
  
)

export default component.exports